<template>
  <b-card no-body>
    <b-card-header class="pb-100">
      <h5> {{ $t('FILTERS_TITLE') }} </h5>
    </b-card-header>
    <b-card-body>
              <b-row>
                  <b-col lg="6" md="12" class="mb-md-0 mb-2">
                    <label>{{ $t('FILTERS_OWNERS_TITLE') }}</label>
                    <v-select
                      multiple 
                      :close-on-select="false" 
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
                      @input="(value) => {
                        $store.commit('containerAreaPlan.list/updateOwnersFilter', { value })
                        $store.dispatch('containerAreaPlan.list/fetchList')
                      }" 
                      :value="$store.getters['containerAreaPlan.list/ownersFilter']" 
                      :options="$store.getters['containerAreaPlan.list/ownersOptions']" 
                      label="name"
                      class="w-100" 
                      :reduce="owner => owner.id"
                      :getOptionLabel="owner => owner.name" 
                    />
                  </b-col>

                  <b-col lg="6" md="12" class="mb-md-0 mb-2">
                    <label>{{ $t('FILTERS_CONTRACTS_TITLE') }}</label>
                    <v-select 
                      multiple 
                      :close-on-select="false" 
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
                      @input="(value) => {
                        $store.commit('containerAreaPlan.list/updateContractsFilter', { value })
                        $store.dispatch('containerAreaPlan.list/fetchList')
                      }" 
                      :value="$store.getters['containerAreaPlan.list/contractsFilter']"
                      :options="$store.getters['containerAreaPlan.list/contractsOptions']"
                      class="w-100" 
                      :reduce="contract => contract.id"
                      :getOptionLabel="contract => contract.name" 
                    />
                  </b-col>

              </b-row>
    </b-card-body>
  </b-card>
</template>

<script>

import {
  BCard, 
  BCardHeader, 
  BCardBody, 
  BRow, 
  BCol, 
  BButton
} from 'bootstrap-vue'

import vSelect from 'vue-select'

export default {
  components: {
    BRow, 
    BButton,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
